import type { FeatureModule } from "../types";
import { VoiceOps } from "./VoiceOps";

export const orchestratorFeature: FeatureModule = {
  id: "orchestrator",
  path: "/orchestrator",
  label: "Voice ops",
  nav: false,
  element: VoiceOps,
};

export { VoiceOps } from "./VoiceOps";
